import {Component, h} from 'preact'
import Icon from '../../assets'
import ButtonControl from '../../button-control'
import {BulkAction} from "../index";
import axios from "axios";
import GroupSelector, {Group} from '../../groups/GroupSelector';
import RadioInputGroup from "../../ui-components/RadioInputGroup";
import {Modal, ModalBody, ModalFooter, ModalHeader} from '../../modal'
import InputGroup from '../../ui-components/InputGroup'
import Textarea from '../../ui-components/Textarea'
import { common } from '../../common'

type Props = {
  numberOfSelectedContacts: number,
  performBulkAction: (bulkAction: BulkAction) => void,
}

type State = {
  isContactInviteModalOpen: boolean,
  inviteType: string,
  inviteTypeChoices: string[],
  groupId?: number,
  groups: Group[],
  customMessage: string
  selectGroupError: string
}

type Contact = {
  email: string
  id: number
  importId: string
  invite: any|null
  name: string
  userTags: string[]
}

export const inviteContact = () => ({
  Component: ({numberOfSelectedTopics, performBulkAction}: { numberOfSelectedTopics: number, performBulkAction: (bulkAction: BulkAction) => void }) =>
    <InviteContact
      numberOfSelectedContacts={numberOfSelectedTopics}
      performBulkAction={performBulkAction}
    />
})

const joinCommunityAndGroup = 'Join community and a group'
const joinCommunity = 'Join community'

class InviteContact extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isContactInviteModalOpen: false,
      inviteType: joinCommunity,
      inviteTypeChoices: [joinCommunity],
      customMessage: '',
      groups: [],
      selectGroupError: ''
    }
  }
  async componentDidMount () {
    if (!common.isModuleActive('group')) {
      return
    }
    await axios.get('/group/list')
      .then((res) => {
        this.setState({
          groups: res.data as Group[],
          inviteTypeChoices: [joinCommunity, joinCommunityAndGroup]
        })
      })
      .catch(() => {})
  }

  onInviteContact = () => {
    const {performBulkAction} = this.props
    const {inviteType, groupId, customMessage} = this.state

    if (inviteType === joinCommunityAndGroup && !groupId) {
      this.setState({selectGroupError: 'Please select a group.'})
      return
    }

    const isGroupInvite = inviteType === joinCommunityAndGroup

    const bulkAction = {
      successMessage: 'Invitations have been sent successfully',
      onClick: async (selectedContacts: Contact[]) => {
        const selectedContactsIds = selectedContacts.map((contact: Contact) => (contact.id))

        axios.post('/contact/invite', {
          'customMessage': customMessage,
          'groupId': isGroupInvite ? groupId : null,
          'contacts': selectedContactsIds
        })
      }
    }

    performBulkAction(bulkAction)
    this.setState({isContactInviteModalOpen: false})

  }

  render(props: Props, state: State) {
    const {numberOfSelectedContacts} = props
    const {isContactInviteModalOpen, selectGroupError, inviteTypeChoices, inviteType, groups, customMessage} = state

    return <div>
      <ButtonControl
        title={<div><Icon icon='addUser'/>Send invite</div>}
        size='medium'
        newStyle
        variant='secondary'
        class='qa-invite-contact'
        onClick={() => this.setState({isContactInviteModalOpen: true})}
      />
      {isContactInviteModalOpen && <Modal isOpen={isContactInviteModalOpen} size='medium'>
        <ModalHeader
          title={`Send invite to ${numberOfSelectedContacts} contact${numberOfSelectedContacts > 1 ? 's' : ''}`}
          onClose={() => this.setState({isContactInviteModalOpen: false})}/>
        <ModalBody>
          <div className='contact-invite-modal'>
            <RadioInputGroup
              title={'Invite contacts to'}
              options={inviteTypeChoices}
              onChange={(option) => this.setState({inviteType: option, selectGroupError: ''})}
              value={inviteType}
              underneath
            />
            {groups.length > 0 && <div className='group-select-wrapper'>
              <InputGroup
                customInput={<GroupSelector
                  groups={groups}
                  onGroupSelected={(groupId: number) => this.setState({groupId, selectGroupError: ''})}
                  disabled={inviteType === joinCommunity}
                />}
                error={selectGroupError}
              />
            </div>}
            <label className='contact-invite-modal__textarea-label'>Invite message</label>
            <div>It’s more likely for people to accept an invite if there is a personalised message attached.</div>
            <Textarea
              adjustHeight
              class='contact-invite-modal__textarea'
              placeholder='e.g. Nice to meet you at the event, let’s stay in touch in the community.'
              newStyle
              onContentChange={(value: string) => this.setState({customMessage: value})}
              value={customMessage}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonControl
            title='Send invite via email'
            newStyle
            onClick={this.onInviteContact}
            size='medium'
            variant='brand'
          />
        </ModalFooter>
      </Modal>}
    </div>
  }
}

